import React from 'react';
import "./Header.css"


const Header = () => {
    return (
        <div className='header'>
            <h2 className='txt-hdr'>WATCH BURG </h2>
            <hr />
        </div>
    );
};

export default Header;